export const wierdFemaleNames: string[] = [
  'Aileen',
  'Ailyn',
  'Akivi',
  'Alcides',
  'Aleen',
  'Aleph',
  'Alercy',
  'Alex',
  'Alexis',
  'Alexsis',
  'Alez',
  'Alice',
  'Aline',
  'Alinsson',
  'Alipsis',
  'Alison',
  'Allison',
  'Allyson',
  'Alvis',
  'Alyson',
  'Ambar',
  'Anabel',
  'Anabelen',
  'Analy',
  'Anays',
  'Andaluz',
  'Andori',
  'Angie',
  'Angry',
  'Anis',
  'Anjel',
  'Anllely',
  'Anyeline',
  'Anyell',
  'Araceli',
  'Aracelli',
  'Aracely',
  'Ardile',
  'Arlé',
  'Astrid',
  'Astry',
  'Asunción',
  'Auggi',
  'Autor',
  'Aydee',
  'Aylen',
  'Aylin',
  'Baitiare',
  'Baleri',
  'Batian',
  'Beatriz',
  'Bebell',
  'Bebelyn',
  'Belen',
  'Belén',
  'Bendy',
  'Benilde',
  'Bentzabé',
  'Berenice',
  'Berenise',
  'Bernabe',
  'Bernabé',
  'Bernal',
  'Betabe',
  'Betsabe',
  'Betsabé',
  'Betsabet',
  'Betsie',
  'Betsy',
  'Betty',
  'Bety',
  'Betzabe',
  'Betzabé',
  'Betzabet',
  'Beverly',
  'Bexire',
  'Birgill',
  'Blas',
  'Bogni',
  'Boris',
  'Brendaly',
  'Briddie',
  'Briggitte',
  'Brigite',
  'Brigitte',
  'Britt',
  'Bruny',
  'Candy',
  'Caren',
  'Carmen',
  'Cármen',
  'Carol',
  'Carolain',
  'Carolay',
  'Carolayn',
  'Caroline',
  'Carolinne',
  'Carolyn',
  'Carrie',
  'Caterin',
  'Catherien',
  'Catherine',
  'Catherinne',
  'Catheryn',
  'Cathonre',
  'Cathy',
  'Celeste',
  'Celine',
  'Charlott',
  'Chaterine',
  'Cherie',
  'Cherry',
  'Chirley',
  'Chrisleynne',
  'Cibell',
  'Cidy',
  'Cindy',
  'Civell',
  'Cladis',
  'Claribel',
  'Clemete',
  'Clondy',
  'Clorinde',
  'Clotilde',
  'Connie',
  'Cony',
  'Cosme',
  'Cristal',
  'Cristi',
  'Cristine',
  'Cristix',
  'Cristy',
  'Critel',
  'Cruz',
  'Dafne',
  'Daise',
  'Daisy',
  'Dalal',
  'Damari',
  'Damarie',
  'Damaris',
  'Dámaris',
  'Damariys',
  'Danae',
  'Daniluz',
  'Danis',
  'Darby',
  'Daris',
  'Darlin',
  'Dasmari',
  'Dayce',
  'Daysi',
  'Daysy',
  'Deborah',
  'Deborath',
  'Deisy',
  'Delfine',
  'Deliz',
  'Delly',
  'Demian',
  'Denise',
  'Denisse',
  'Dennise',
  'Desiree',
  'Deyse',
  'Deysi',
  'Diamantin',
  'Diane',
  'Dioliz',
  'Divis',
  'Dixie',
  'Dolly',
  'Dolores',
  'Dominic',
  'Dominick',
  'Dominig',
  'Dominique',
  'Dominque',
  'Donalyn',
  'Doralee',
  'Dorcas',
  'Dori',
  'Doris',
  'Dorís',
  'Dorys',
  'Dubel',
  'Ebelin',
  'Edely',
  'Edil',
  'Edith',
  'Edth',
  'Edtih',
  'Eduviges',
  'Eduvigis',
  'Edy',
  'Efrei',
  'Eidth',
  'Elbi',
  'Eldy',
  'Elenis',
  'Elezabeth',
  'Eliacid',
  'Elias',
  'Elías',
  'Elide',
  'Elided',
  'Elieth',
  'Eliette',
  'Elinor',
  'Elisabeth',
  'Eliset',
  'Elizabeht',
  'Elizabet',
  'Elizabeth',
  'Elizabhet',
  'Elizabteh',
  'Elizaneth',
  'Elizatech',
  'Elizbeth',
  'Elliete',
  'Elly',
  'Elonor',
  'Eloy',
  'Elsi',
  'Elsie',
  'Elvis',
  'Ely',
  'Emely',
  'Emilit',
  'Emperatriz',
  'Encarnacion',
  'Engie',
  'Enny',
  'Enriquez',
  'Eny',
  'Erlit',
  'Erlyn',
  'Escarlet',
  'Escarlette',
  'Eskarlet',
  'Estefani',
  'Estefanie',
  'Estefany',
  'Estephany',
  'Ester',
  'Estivaliz',
  'Etienne',
  'Eunibe',
  'Eunice',
  'Evafrez',
  'Evelin',
  'Eveling',
  'Eveliy',
  'Evelyn',
  'Evelyng',
  'Even',
  'Fabiany',
  'Fallown',
  'Fanny',
  'Fany',
  'Flor',
  'Fuentes',
  'Funny',
  'Gaby',
  'Galdamez',
  'Galdys',
  'Gariz',
  'Genesis',
  'Génesis',
  'Georgette',
  'Geraldine',
  'Gertrudis',
  'Ghislaine',
  'Gilds',
  'Ginette',
  'Giorgos',
  'Giovanny',
  'Gisel',
  'Giselle',
  'Gissel',
  'Gisselle',
  'Gisset',
  'Gladis',
  'Glady',
  'Gladys',
  'Gladyz',
  'Glasdys',
  'Glasys',
  'Glorit',
  'Gomez',
  'Grace',
  'Gradys',
  'Gregory',
  'Griccette',
  'Gricel',
  'Grimanett',
  'Grisel',
  'Grissel',
  'Grissell',
  'Guadalupe',
  'Guiselle',
  'Gutierrez',
  'Haide',
  'Hailline',
  'Harely',
  'Hasnay',
  'Haydde',
  'Haydee',
  'Haydeé',
  'Haydée',
  'Hedos',
  'Hedy',
  'Heidy',
  'Hei-Raji',
  'Helen',
  'Hellen',
  'Henyn',
  'Hinave',
  'Hind',
  'Hlsie',
  'Horiet',
  'Humilde',
  'Idalide',
  'Ide',
  'Ides',
  'Ilce',
  'Ilse',
  'Indrid',
  'Ines',
  'Inés',
  'Ingar',
  'Inge',
  'Ingrid',
  'Irene',
  'Irenes',
  'Iris',
  'Irseley',
  'Isabel',
  'Isable',
  'Isaias',
  'Isaías',
  'Isamar',
  'Isis',
  'Isolde',
  'Issis',
  'Itamar',
  'Ivett',
  'Ivette',
  'Ivon',
  'Ivone',
  'Ivonne',
  'Jaanelli',
  'Jackeline',
  'Jackelines',
  'Jaclyn',
  'Jacqelinne',
  'Jacquelin',
  'Jacqueline',
  'Jacquelinne',
  'Jalabet',
  'Jalile',
  'Jamet',
  'Jamett',
  'Jamilet',
  'Jamileth',
  'Jamily',
  'Jane',
  'Janeh',
  'Janet',
  'Janeth',
  'Janett',
  'Janette',
  'Janis',
  'Jannett',
  'Jannifer',
  'Janny',
  'Janquelin',
  'Janys',
  'Jaquelin',
  'Jaqueline',
  'Jaquelinne',
  'Jasmin',
  'Jasmín',
  'Javier',
  'Jazmin',
  'Jazmín',
  'Jazmine',
  'Jeamir',
  'Jeanet',
  'Jeanette',
  'Jeannete',
  'Jeannette',
  'Jeiny',
  'Jenifer',
  'Jeniffer',
  'Jenni',
  'Jennie',
  'Jennifer',
  'Jenniffer',
  'Jenny',
  'Jeny',
  'Jeremias',
  'Jeremías',
  'Jertrudis',
  'Jesielle',
  'Jessie',
  'Jessy',
  'Jesus',
  'Jetzabeth',
  'Jeysi',
  'Jezabel',
  'Jimmy',
  'Jocelin',
  'Joceline',
  'Jocely',
  'Jocelyn',
  'Jochebet',
  'Johanne',
  'Joice',
  'Joise',
  'Jonny',
  'Josabeth',
  'Joselin',
  'Joseline',
  'Joselyn',
  'Joselyne',
  'Joset',
  'Josmery',
  'Josselin',
  'Josselyn',
  'Josselyne',
  'Josue',
  'Jovanny',
  'Joyce',
  'Judith',
  'Julie',
  'July',
  'Juri',
  'Kabir',
  'Kandy',
  'Karel',
  'Karem',
  'Karen',
  'Karent',
  'Karin',
  'Karol',
  'Karoll',
  'Karolyn',
  'Karyn',
  'Katerin',
  'Katerine',
  'Katherine',
  'Katherinne',
  'Katherryn',
  'Katheryn',
  'Katheryne',
  'Kati',
  'Katrid',
  'Kattie',
  'Katty',
  'Katy',
  'Kenedy',
  'Keneth',
  'Keny',
  'Ketherine',
  'Ketty',
  'Keylin',
  'Kimberlee',
  'Kimberlin',
  'Kimberly',
  'Kindy',
  'Kissy',
  'Kistell',
  'Krissey',
  'Kristel',
  'Kuiny',
  'Kwang',
  'Lady',
  'Latrille',
  'Lay',
  'Leddy',
  'Leidi',
  'Leilian',
  'Leivi',
  'Lelis',
  'Lenny',
  'Leny',
  'Leonidas',
  'Leonides',
  'Leonor',
  'Lery',
  'Lesley',
  'Lesli',
  'Leslic',
  'Leslie',
  'Lesliee',
  'Lesly',
  'Leyre',
  'Libertad',
  'Lidi',
  'Lilette',
  'Lili',
  'Liliam',
  'Lilian',
  'Lilianet',
  'Lilibeth',
  'Lily',
  'Lilyan',
  'Lindsay',
  'Lisbeht',
  'Lisbet',
  'Lisec',
  'Liselotte',
  'Lisesette',
  'Lisett',
  'Lisette',
  'Lisetty',
  'Lismey',
  'Lissete',
  'Lissette',
  'Lissettte',
  'Litter',
  'Liz',
  'Lizbeth',
  'Lizette',
  'Llany',
  'Llilian',
  'Lngrid',
  'Lopez',
  'Loreine',
  'Loren',
  'Lorraine',
  'Lory',
  'Lossette',
  'Lourdes',
  'Loveley',
  'Luci',
  'Lucy',
  'Lugardis',
  'Luly',
  'Lus',
  'Luz',
  'Lvonne',
  'Lycel',
  'Lylian',
  'Lysset',
  'Mabel',
  'Mabelyn',
  'Mac',
  'Maciel',
  'Macqueen',
  'Madai',
  'Madel',
  'Madelaine',
  'Madeleine',
  'Madelen',
  'Madelien',
  'Madeline',
  'Madelyne',
  'Magali',
  'Magaly',
  'Maggi',
  'Maggie',
  'Mahazen',
  'Mai',
  'Maibel',
  'Maibeth',
  'Maickol',
  'Maicol',
  'Maikol',
  'Mailen',
  'Maite',
  'Majoret',
  'Majorie',
  'Makari',
  'Maleny',
  'Manuekl',
  'Manurangi',
  'Marcedes',
  'Marcial',
  'Marcos',
  'Margalet',
  'Margaret',
  'Margarett',
  'Margorie',
  'Margory',
  'Margot',
  'Margoth',
  'Margvic',
  'Mari',
  'Marian',
  'Mariane',
  'Marianne',
  'Maribel',
  'Maricarmen',
  'Maricel',
  'Marie',
  'Mariel',
  'Mariele',
  'Marilen',
  'Marilin',
  'Marilu',
  'Marilú',
  'Mariluz',
  'Marilyn',
  'Marioly',
  'Marion',
  'Marión',
  'Marisel',
  'Marisiol',
  'Marisol',
  'Marixi',
  'Marjori',
  'Marjorie',
  'Marlen',
  'Marlene',
  'Marleny',
  'Martínez',
  'Mary',
  'Marybell',
  'Marycarmen',
  'Marylin',
  'Maryorie',
  'Maryorit',
  'Marysel',
  'Masiel',
  'Massiel',
  'Matielde',
  'Matilde',
  'Matzys',
  'Maureen',
  'Mauren',
  'Maxi',
  'Maye',
  'Mayerling',
  'Mayleen',
  'Mayorie',
  'Medy',
  'Melani',
  'Melanie',
  'Melany',
  'Melody',
  'Merahi',
  'Mercedes',
  'Mercedez',
  'Meriller',
  'Mery',
  'Michelle',
  'Milagros',
  'Milde',
  'Milian',
  'Millaray',
  'Milton',
  'Minay',
  'Miriam',
  'Mirian',
  'Miryam',
  'Misury',
  'Mitsi',
  'Mitzi',
  'Mitzy',
  'Mixy',
  'Monserrat',
  'Montserrat',
  'Montserratt',
  'Montserratte',
  'Mry',
  'Murhiel',
  'Myiriam',
  'Mylene',
  'Myriam',
  'Myriams',
  'Myrian',
  'Mytzy',
  'Nacy',
  'Nadine',
  'Nahtaly',
  'Nakatani',
  'Naldy',
  'Nallaret',
  'Nalleli',
  'Nallely',
  'Nanci',
  'Nancy',
  'Nansi',
  'Narcy',
  'Nardy',
  'Natali',
  'Natalie',
  'Nataly',
  'Nátaly',
  'Natalye',
  'Nataniel',
  'Natay',
  'Nathalie',
  'Nathaly',
  'Nathaty',
  'Natividad',
  'Nayabet',
  'Nayade',
  'Nayadedth',
  'Nayadet',
  'Nayadeth',
  'Nayaret',
  'Nayareth',
  'Nayarret',
  'Nayie',
  'Nayoleithi',
  'Neftali',
  'Negme',
  'Nelley',
  'Nelly',
  'Nelsi',
  'Nelsy',
  'Nely',
  'Neolides',
  'Nephtali',
  'Neri',
  'Nery',
  'Nerys',
  'Nice',
  'Nicholas',
  'Nicol',
  'Nicolas',
  'Nicolás',
  'Nicole',
  'Nicolle',
  'Nicols',
  'Nieve',
  'Nieves',
  'Nikole',
  'Noemi',
  'Noemí',
  'Nohemí',
  'Noli',
  'Nori',
  'Noris',
  'Nuby',
  'Nure',
  'Nuris',
  'Nury',
  'Nurys',
  'Nycolle',
  'Odett',
  'Odette',
  'Oldeny',
  'Paitiare',
  'Paitiave',
  'Patrice',
  'Paty',
  'Paulette',
  'Pauline',
  'Paz',
  'Peggy',
  'Petzabel',
  'Pilar',
  'Polet',
  'Polett',
  'Polette',
  'Poulette',
  'Presales',
  'Quenne',
  'Rachel',
  'Raquel',
  'Rayen',
  'Rayentru',
  'Rerux',
  'Rith',
  'Romane',
  'Romané',
  'Romanet',
  'Romy',
  'Rosamel',
  'Rosemary',
  'Rosemay',
  'Rosemery',
  'Rosy',
  'Roxane',
  'Ru',
  'Rubi',
  'Rubí',
  'Rud',
  'Rudith',
  'Rut',
  'Ruth',
  'Ruthy',
  'Sadie',
  'Salome',
  'Santos',
  'Sany',
  'Sarah',
  'Scarlet',
  'Scarleth',
  'Scarlett',
  'Scarlette',
  'Scharezade',
  'Selene',
  'Sernee',
  'Sharoon',
  'Shirley',
  'Sidny',
  'Sigrid',
  'Silvestr',
  'Simay',
  'Sindy',
  'Sissi',
  'Solange',
  'Soledad',
  'Soram',
  'Stefanie',
  'Stefany',
  'Steling',
  'Stephanie',
  'Stephany',
  'Stepman',
  'Sthepanie',
  'Sthephanie',
  'Stivensalvarez',
  'Sucy',
  'Sugey',
  'Sullyn',
  'Sulver',
  'Susan',
  'Susanne',
  'Sussi',
  'Sussy',
  'Susy',
  'Suzy',
  'Tamari',
  'Tami',
  'Thamar',
  'Tiare',
  'Tiaren',
  'Tipanie',
  'Trinidad',
  'Vai',
  'Valeri',
  'Valery',
  'Vasthi',
  'Vianny',
  'Viany',
  'Vicky',
  'Virtudes',
  'Vivian',
  'Vivían',
  'Viviane',
  'Vivianne',
  'Vivien',
  'Xanny',
  'Yacqueline',
  'Yael',
  'Yamile',
  'Yamilet',
  'Yamilett',
  'Yandari',
  'Yaneli',
  'Yanelly',
  'Yanet',
  'Yaneth',
  'Yanett',
  'Yani',
  'Yaniri',
  'Yannet',
  'Yannette',
  'Yasmin',
  'Yasmín',
  'Yasnadi',
  'Yayori',
  'Yazmín',
  'Yeanette',
  'Yeimi',
  'Yeisel',
  'Yeisy',
  'Yeni',
  'Yenifer',
  'Yennifer',
  'Yenny',
  'Yennyfer',
  'Yeny',
  'Yerely',
  'Yerifert',
  'Yerty',
  'Yimberly',
  'Yisel',
  'Yisselle',
  'Yocelyn',
  'Yolmet',
  'Yoselin',
  'Yoselyn',
  'Ysabet',
  'Yucari',
  'Yudith',
  'Yuing',
  'Yuri',
  'Zatry',
  'Zuny',
];
